import { ApiClient } from "../../ApiClient";
import { ContactUsForm, WorkWithUsForm } from "@/@types/FormData";



export const sendContactUsForm = async (contactUsForm: ContactUsForm | WorkWithUsForm | FormData) => {
  const client = ApiClient.getInstance(); 
  const response = await client.post("send-email", contactUsForm); 
  return response;
};
